import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { initializeExternalNS } from '../../hooks/useExternalNS.js';
const CHAT_NAMESPACE = 'chatbot';
const CHAT_BUTTON_EXTERNAL_NAME = 'text-page__btn-chat';
const CHAT_FRAME_ID = 'webchat-js-container:webchat_rshb';
const CHAT_STORAGE_NAME = 'webchat-keep-open';
const CHATBOT_URL = {
    personal: '//chat.mes.rshb.ru/assets/js/webchat_rshb',
    business: '', //TODO: add url business chat
};
export const useChatBot = (chat) => {
    useEffect(() => globalThis.localStorage?.setItem(CHAT_STORAGE_NAME, String(Date.now())), []);
    const chatUrl = CHATBOT_URL[chat ?? ''];
    return (ev) => {
        if (!chatUrl) {
            return;
        }
        if (chat !== 'personal') {
            initializeExternalNS(CHAT_NAMESPACE, chatUrl);
        }
        else {
            const target = ev.target;
            if (!target?.classList.contains(CHAT_BUTTON_EXTERNAL_NAME)) {
                target?.classList.add(CHAT_BUTTON_EXTERNAL_NAME);
            }
            const chatFrame = document.getElementById(CHAT_FRAME_ID);
            if (!chatFrame) {
                initializeExternalNS(CHAT_NAMESPACE, chatUrl);
            }
        }
    };
};
//# sourceMappingURL=useChatBot.js.map